export const setupVideos = [
  {
    label: 'Invite Team (2 min)',
    url: 'https://vimeo.com/744850460/7cf4b29f00',
  },
  { label: 'Add Logo (1 min)', url: 'https://vimeo.com/744851108/91d8eaca12' },
  {
    label: 'Apply Link (1 min)',
    url: 'https://vimeo.com/744851491/debb81917d',
  },
  {
    label: 'Connect Utility Provider (1 min)',
    url: 'https://vimeo.com/744852006/8b34327ef8',
  },
  {
    label: 'Connect Property Uploader (1 min)',
    url: 'https://vimeo.com/744852446/137e3a3145',
  },
  {
    label: 'Turn on your enquiry autoresponder (2 min)',
    url: 'https://vimeo.com/744852933/afa98e3ccc',
  },
  {
    label: 'Disable Other Application Forms (1 min)',
    url: 'https://vimeo.com/744854044/816701dd28',
  },
  {
    label: 'Connect Property Management Software (2 min)',
    url: 'https://vimeo.com/744854451/543694f9e9',
  },
  {
    label: 'Update website with Apply Link (1 min)',
    url: 'https://vimeo.com/744854928/21f218ad58',
  },
  {
    label: 'Lease Offer (3 min)',
    url: 'https://vimeo.com/744855365/0e21b10240',
  },
  {
    label: 'Common settings - applicants (3 min)',
    url: 'https://vimeo.com/1001401427',
  },
  {
    label: 'Common settings - viewings (1 min)',
    url: 'https://vimeo.com/1001401401',
  },
  {
    label: 'Onlist (3 min)',
    url: 'https://vimeo.com/1001401559',
  },
]

export const applicationsVideos = [
  {
    label: 'Processing Applications (5 min)',
    url: 'https://vimeo.com/1001401323',
  },
  {
    label: 'Dashboard (2 min)',
    url: 'https://vimeo.com/1001401295',
  },
  {
    label: 'How renters apply using Snug (4 min)',
    url: 'https://vimeo.com/745623284/8259d65156',
  },
  {
    label: 'Screening applicants (1 min)',
    url: 'https://vimeo.com/1001401483',
  },
]

export const viewingsVideos = [
  {
    label: 'Viewings (3 min)',
    url: 'https://vimeo.com/1001401508',
  },
  {
    label: 'Viewings on mobile (2 min)',
    url: 'https://vimeo.com/1001401243',
  },
  {
    label: 'Messages (2 min)',
    url: 'https://vimeo.com/993257534/5e172cbe55',
  },
  {
    label: 'Key Management (3 min)',
    url: 'https://vimeo.com/745620508/a238adc137',
  },
  {
    label: 'QR Code (2 min)',
    url: 'https://vimeo.com/1001401271',
  },
]

export const trainingVideos = [
  {
    label: 'New User Training (30 min)',
    url: 'https://vimeo.com/745618542/7d8e12ff52',
  },
  {
    label: 'Support (1 min)',
    url: 'https://vimeo.com/1001401591',
  },
]
